import type { ReactNode } from 'react';

interface CycleHeaderProps {
  cycleNumber: number;
  titleClassName?: string;
  trailing?: ReactNode;
}

/** Standard cycle title row (e.g. before start session). */
export default function CycleHeader({
  cycleNumber,
  titleClassName = 'text-xl font-bold text-gray-800',
  trailing,
}: CycleHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <h2 className={titleClassName}>Cycle {cycleNumber}</h2>
      {trailing}
    </div>
  );
}
